import {colorNames, useNamedColor} from '@github-ui/use-named-color'
import {IssueOpenedIcon} from '@primer/octicons-react'
import {SharedPicker} from '@github-ui/item-picker-base/SharedPicker'
import {LABELS} from '@github-ui/item-picker-base/constants/labels'
import type {IssueTypePickerBaseProps} from './IssueTypePickerBase'
import styles from './DefaultIssueTypePickerAnchor.module.css'

export type DefaultIssueTypePickerAnchorProps = Pick<IssueTypePickerBaseProps, 'activeIssueType' | 'readonly'> & {
  ariaLabelledBy?: string
  anchorProps?: React.HTMLAttributes<HTMLElement> | undefined
} & {ref?: React.Ref<HTMLButtonElement>}

const IssueTypeDot = ({color}: {color: string}) => {
  const effectiveColor = colorNames.find(c => c === color)
  const {fg} = useNamedColor(effectiveColor)

  return <div style={{'--bg': `${fg}`} as React.CSSProperties} className={styles.issueTypeDot} />
}

export const DefaultIssueTypePickerAnchor = ({
  ref,
  activeIssueType,
  readonly,
  anchorProps,
}: DefaultIssueTypePickerAnchorProps) => {
  return (
    <SharedPicker
      anchorText={LABELS.noIssueTypes}
      sharedPickerMainValue={activeIssueType?.name}
      anchorProps={readonly ? undefined : anchorProps}
      ariaLabel={LABELS.selectIssueTypes}
      readonly={readonly}
      leadingIcon={IssueOpenedIcon}
      hotKey={undefined}
      ref={ref}
      leadingIconElement={activeIssueType && <IssueTypeDot color={activeIssueType.color} />}
    />
  )
}

DefaultIssueTypePickerAnchor.displayName = 'DefaultIssueTypePickerAnchor'
